// extracted by mini-css-extract-plugin
export default {"customLabel-left":"FormLogin_customLabel-left__1pCso"};